import React from 'react';

const Header = () => {
  return (
    <header className="bg-brand-secondary/90 backdrop-blur-sm shadow-lg p-4 border-b border-brand-primary">
      <div className="container mx-auto flex items-center justify-center md:justify-start">
        <div className="flex items-center">
          <img src="/orizzontale-con-slogan.png" alt="Saving Solutions" className="h-12 md:h-16 brightness-0 invert" />
        </div>
      </div>
    </header>
  );
};

export default Header;
